import { useEffect } from "react";
import i18n from "@/i18n";

export const INSTITUTION_LANGUAGE_KEY = "institutionLanguage";

export function usePrintLanguage() {
  useEffect(() => {
    const previous = i18n.language;
    const institution = localStorage.getItem(INSTITUTION_LANGUAGE_KEY);
    if (institution && institution !== previous) i18n.changeLanguage(institution);
    return () => { if (i18n.language !== previous) i18n.changeLanguage(previous); };
  }, []);
}
